import {
  base_colorContentBorder,
  blue400,
  grey700,
  notification_colorAlert,
  purple400,
  tag_colorTagBlueBackgroundHover,
  tag_colorTagNewBackground,
  tag_colorTagPendingBackground,
  tag_colorTagSevereBackground,
  yellow200,
  yellow800,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { css } from 'styled-components'

export default css`
  padding: ${spacing(4)} ${spacing(5)};
  border-radius: 6px;
  border: 1px solid transparent;

  // VARIANTS
  &.default {
    background-color: ${tag_colorTagBlueBackgroundHover};
    color: ${blue400};
    border-color: ${blue400};
  }

  &.warning {
    background-color: ${tag_colorTagPendingBackground};
    color: ${yellow800};
    border-color: ${yellow200};
  }

  &.severe {
    background-color: ${tag_colorTagSevereBackground};
    color: ${notification_colorAlert};
    border-color: ${notification_colorAlert};
  }

  &.automation {
    background-color: ${tag_colorTagNewBackground};
    color: ${purple400};
    border-color: ${purple400};
  }

  &.wcag {
    color: ${grey700};
    border-color: ${base_colorContentBorder};
  }
`
